<div
  class="custom-select"
  tabindex="0"
  (click)="toggleDropdown()"
  (keydown)="onKeydown($event)"
>
  <div
    class="selected-value"
    [ngStyle]="{
      backgroundColor: selectedValue ?? null,
      color: selectedValue === 'Black' ? 'white' : null
    }"
  >
    {{ selectedValue || "Choose border color" }}
  </div>
  @if (dropdownOpen) {
  <div class="options">
    @for (option of options; track $index) {
    <div
      class="option"
      tabindex="0"
      [style.backgroundColor]="option.value"
      [ngStyle]="{ color: option.value === 'black' ? 'white' : null }"
      (click)="selectOption(option)"
      (keydown)="onOptionKeydown($event, option)"
    >
      {{ option.viewValue }}
    </div>
    }
  </div>
  }
</div>
@if (dropdownOpen) {
<div
  class="overlay"
  tabindex="0"
  (click)="closeDropdown()"
  (keypress)="closeDropdown()"
></div>
}
